// import Axios from 'axios';

export const WarningHandler = (msg, vm, trace) => {
  console.warn(msg);

  // Post to graylog
  // Axios.post(url, { data });
};
